import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";
import { useEffect, useState } from "react";
import "./layout.css";
import { useGlobalContext } from "../context/GlobalContext";
import CartSection from "../components/ui/cartSection/CartSection";
import CartDetails from "../components/ui/cartDetails/CartDetails";
import ClientForm from "../components/ui/clientForm/ClientForm";
import EmptyScreen from "../components/ui/emptyScreen/EmptyScreen";
import HomeHeader from "../components/ui/childHeader/HomeHeader";
import SalesPersonModal from "../components/ui/salesPersonModal";
import { getIcon } from "../utils/iconConfig";

const HomeLayout = () => {
  const {
    scanned,
    homeScreen,
    setHomeScreen,
    cartData,
    clientForm,
    setOrderComplete,
    setSelectedCard,
  } = useGlobalContext();
  const [dropboxOpen, setDropboxOpen] = useState(false);

  useEffect(() => {
    const user = localStorage.getItem("scanned");
    const name = JSON.parse(localStorage.getItem("ClientData"));

    if (user && name) {
      setHomeScreen(true);
      // setClientForm(false);
      setOrderComplete(false);
    }
    return () => {
      setHomeScreen(false);
    };
  }, [scanned]);

  useEffect(() => {
    if (cartData.length === 0) {
      setHomeScreen(false);
    }
    if (cartData.length === 1) {
      setSelectedCard(cartData[cartData.length - 1]?.styleNumber);
    }
  }, [cartData]);

  return (
    <Box className="main-container">
      <Box className="secondary-container">
        {!clientForm ? (
          <Box className="main-section">
            <ClientForm />
          </Box>
        ) : (
          <>
            <Box
              className="cart-section"
              sx={{
                width: "24vw",
              }}
            >
              <CartDetails />
              <CartSection />
            </Box>
            <Box className="main-section">
              <HomeHeader />
              {!homeScreen && cartData.length === 0 && (
                <EmptyScreen page="home" />
              )}
              {homeScreen && <Outlet />}
            </Box>
            <div
              style={{
                cursor: "pointer",
                position: "absolute",
                bottom: "2vw",
                right: "2vw",
              }}
              onClick={() => setDropboxOpen(!dropboxOpen)}
            >
              {dropboxOpen
                ? getIcon("SalesPerson", "cancel")
                : getIcon("SalesPerson")}
            </div>
          </>
        )}
      </Box>
      <SalesPersonModal
        open={dropboxOpen}
        onClose={() => setDropboxOpen(false)}
      />
    </Box>
  );
};

export default HomeLayout;
